var render = function () {
var _obj, _obj$1;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"c-spinner",class:( _obj = {
    'tw-inline-block': true
  }, _obj[_vm.size] = true, _obj )},[_c('div',{staticClass:"animation",class:[
      ( _obj$1 = {
        'tw-border-gray-400': !_vm.animationClass
      }, _obj$1[_vm.animationClass] = _vm.animationClass, _obj$1 ) ]})])}
var staticRenderFns = []

export { render, staticRenderFns }